//
// Generated class AdyenProxyPaymentInstallment
//

/// <reference path="AdyenProxyPaymentInstallment_ManagedObject.ts" />

class AdyenProxyPaymentInstallment extends AdyenProxyPaymentInstallment_ManagedObject
{

}
